export { default as TrendingUpSolidIcon } from './TrendingUpSolidIcon';
